import { format } from 'date-fns';
import ja from 'date-fns/locale/ja';

import { EventType } from './EventType';
import { convertTypeToContent } from 'main/components/App/Pages/SchedulePage/Schedule/util';

export * from './EventType';
export * from './Place';

export type Event = {
    id?: string;
    type: EventType;
    date: string;
    startTime: string;
    endTime: string;
    place: string;
    description: string;
}

export type CalendarEvent = {
    id?: string;
    title: EventType;
    start: Date;
    end: Date;
    place: string;
    description: string;
}

export type ReferenceDialogData = {
    date: string;
    content: string;
    time: string;
    place: string;
    description: string;
}

export type UpdateDialogData = {
    id?: string;
    type: EventType;
    date: string;
    startDatetime: string;
    endDatetime: string;
    place: string;
    description: string;
}

export const convertToReferanceDialogData = (event: Event): ReferenceDialogData => ({
    date: format(new Date(event.date), 'MM/dd(E)', { locale: ja }),
    content: convertTypeToContent(event.type),
    time: `${event.startTime} - ${event.endTime}`,
    place: event.place,
    description: event.description
})

export const convertToUpdateDialogData = (event: Event): UpdateDialogData => ({
    id: event.id,
    type: event.type,
    date: format(new Date(event.date), 'MM/dd(E)', { locale: ja }),
    startDatetime: `${event.date} ${event.startTime}`,
    endDatetime: `${event.date} ${event.endTime}`,
    place: event.place,
    description: event.description
})
